import {
  useEffect,
  useState,
  useMemo,
  forwardRef,
  Ref,
  useImperativeHandle,
  useRef,
} from "react";
import EmptyField from "./EmptyField";
import SelectableInput from "../SelectableInput/SelectableInput";
import { Field } from "../../types/TenantInterfaces";
import { flushSync } from "react-dom";

interface Props {
  tableView?: boolean;
  recordID: string;
  field: Field;
  value: boolean | null | undefined;
  onUpdate: any;
}

const ToggleRecord = (
  { tableView, recordID, field, value, onUpdate }: Props,
  ref?: Ref<HTMLInputElement>
) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [selected, setSelected] = useState<boolean | null>(null);
  const selectedRef = useRef<boolean | null>(null);

  selectedRef.current = selected;

  const save = (newValue: boolean | null) => {
    if (value !== newValue) {
      onUpdate({
        field,
        recordID,
        payload: {
          [field?.APIName]: newValue,
        },
      });
    }
  };

  const selectRecord = (val: { value: boolean }) => {
    setSelected(val?.value ?? null);
    save(val?.value);
  };

  const deselect = () => {
    setSelected(null);
    save(null);
  };

  const onClear = () => {
    setSelected(null);
    save(null);
  };

  const options = useMemo(() => {
    return [
      {
        label: field.TrueDisplayName,
        value: true,
        color: "#26b058",
        icon: "mdi mdi-check-bold",
      },
      {
        label: field.FalseDisplayName,
        value: false,
        color: "#e72222",
        icon: "mdi mdi-close-thick",
      },
    ];
  }, [field]);

  useEffect(() => {
    setSelected(value === true ? true : value === false ? false : null);
  }, [value]);

  // @ts-ignore
  useImperativeHandle(ref, () => ({
    focus: () => inputRef.current?.focus(),
  }));

  return (
    <div className={`${tableView ? "pr-2" : ""}`}>
      <SelectableInput
        ref={inputRef}
        mode={field.ReadOnly ? "r" : "rw"}
        value={
          selected === true
            ? { label: field.TrueDisplayName, value: true, color: "#26b058" }
            : selected === false
            ? { label: field.FalseDisplayName, value: false, color: "#e72222" }
            : ""
        }
        options={options}
        onSelect={selectRecord}
        color="#DC5013"
        clearable={!field.Required}
        inputDisplayMode="subtle"
        onClear={field.Required ? undefined : onClear}
        onDeselect={field.Required ? undefined : deselect}
        sort={false}
        searchable={false}
        // @ts-ignore
        empty={<EmptyField table={tableView} />}
      />
    </div>
  );
};

export default forwardRef(ToggleRecord);
